import { createNotifyingErrorEffect } from 'utils/store';
import { API } from 'api';

// * effects
export const sendQuestionFx = createNotifyingErrorEffect({
    handler: async (data: API.FeedbackDto) => API.feedback.sendQuestion(data)
});
